var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.2 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 60.88a1.1 1.1 0 0 1-1 0C9 51 5.34 29.84 4.9 18.14a1.09 1.09 0 0 1 .63-1l23.1-11a1 1 0 0 1 .94 0l23.1 11a1.09 1.09 0 0 1 .63 1c-.44 11.7-4.1 32.86-23.7 42.74m27.48-47.07L29.58.61a1.08 1.08 0 0 0-1 0L1.12 13.81a1.1 1.1 0 0 0-.62 1c0 24.84 10.26 43.65 28.15 51.6a1.06 1.06 0 0 0 .9 0c17.89-8 28.15-26.76 28.15-51.6a1.1 1.1 0 0 0-.62-1",
    stroke: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f45000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.82 42.46a11.16 11.16 0 0 0-22.32 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.82,
    cy: 24.61,
    r: 4.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileShield);
export default __webpack_public_path__ + "static/media/profile-shield.7ce1e36b3780e9884cbdf33e32680690.svg";
export { ForwardRef as ReactComponent };